import { Splide, SplideSlide } from '@splidejs/react-splide';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { isEmpty } from 'validate.js';

import BreederProfileParentDogsCarouselSkeleton from 'dpl/components/BreederProfile/Show/skeletons/BreederProfileParentDogsCarouselSkeleton';
import { GENDERS } from 'dpl/shared/constants/breeder_app';

import ParentDogCard from '../shared/ParentDogCard';

export default function ParentDogsCarousel({ isLoading, dogs }) {
  const splideRef = useRef(null);
  const peekable = dogs.length > 1;

  if (isLoading) {
    return <BreederProfileParentDogsCarouselSkeleton />;
  }

  if (isEmpty(dogs)) {
    return null;
  }

  return (
    <div className="ParentDogsCarousel">
      <div className="container-xxl">
        <h4 className="font-24 lh-title pt2 mb6 w-90 mr2">Parent dogs</h4>
      </div>
      <Splide
        ref={splideRef}
        options={{
          arrows: false,
          drag: peekable,
          dragMinThreshold: 20,
          flickMaxPages: 1,
          flickPower: 300,
          gap: 16,
          keyboard: 'focused',
          padding: { left: 24, right: peekable ? 48 : 24 },
          pagination: false,
          perPage: 1,
          snap: true
        }}
      >
        {dogs.map((dog, index) => (
          <SplideSlide key={dog.id}>
            <ParentDogCard
              dog={dog}
              className={classnames('mb1', {
                nr6: peekable && index === dogs.length - 1
              })}
            />
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
}

ParentDogsCarousel.propTypes = {
  dogs: PropTypes.arrayOf(
    PropTypes.shape({
      breed_name: PropTypes.string,
      description: PropTypes.string,
      gender: PropTypes.oneOf(Object.values(GENDERS)),
      health_testing: PropTypes.shape({
        title: PropTypes.string,
        documented_health_tests: PropTypes.arrayOf(PropTypes.string)
      }),
      id: PropTypes.number,
      name: PropTypes.string,
      profile_photo_url: PropTypes.string
    }).isRequired
  ).isRequired,
  isLoading: PropTypes.bool
};

ParentDogsCarousel.defaultProps = {
  isLoading: false
};
